import { render, staticRenderFns } from "./VulnerableTitle.vue?vue&type=template&id=7dc969e4&"
import script from "./VulnerableTitle.vue?vue&type=script&lang=js&"
export * from "./VulnerableTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports